import Radio from "backbone.radio";
import sweetalert from "sweetalert";
import { toast } from "extensions/toast";

import strings from "common/strings";
import {
    copyToClipboard,
    destroyPopovers
} from "common/utils";

import { SmartTable } from "common/components/table/smartTable";
import { SmartTableModel } from "common/components/table/smartTableModel";

import { references } from "common/helpers/references";

export const ViewCredentialsTable = SmartTable.extend({
    initialize(...args) {
        this.model = new SmartTableModel({
            pager: true,
            noDataMessage: "There are no credentials that match your search criteria",
            columns: [
                {
                    name: "Credential name",
                    attribute: "display_name",
                    cell: "text",
                    sortable: true,
                    sortOptions: {
                        active: "1"
                    }
                }, {
                    name: "Protocol",
                    attribute: "protocol",
                    cell: "text",
                    sortable: true,
                    filterable: true,
                    filterOptions: [{
                        name: "ALL",
                        value: "",
                        active: true
                    }, {
                        name: "SFTP",
                        value: "sftp"
                    }, {
                        name: "UI",
                        value: "web-driver"
                    }, {
                        name: "API",
                        value: "api"
                    }, {
                        name: "FTP",
                        value: "ftp"
                    }],
                    beforeRender(content) {
                        if (content === "web-driver") {
                            return "UI";
                        }
                        return content.toUpperCase();
                    }
                }, {
                    name: "Provider",
                    attribute: "processor_name",
                    cell: "text",
                    sortable: true
                }, {
                    name: "Merchant",
                    attribute: (model) => references.toAlias(model.get("merchant_ref"), "merchant"),
                    cell: "text",
                    sortable: true
                }, {
                    // eslint-disable-next-line sentence-case/sentence-case
                    name: "Ref ID",
                    attribute: "_id",
                    cell: "text",
                    cellClassName: "monospace",
                    sortable: true,
                    beforeRender(content) {
                        const first20 = content.substring(0, content.length - 4);
                        const last4 = content.substring(content.length - 4, content.length);
                        return `<span class="lighter">${first20}</span><span class="darker">${last4}</span>`;
                    },
                    width: 225
                }, {
                    name: "Expired date",
                    attribute: "expired_date",
                    cell: "date_time",
                    sortable: true,
                    width: 225
                }, {
                    name: "Active",
                    attribute: "active",
                    cell: "text",
                    sortable: true,
                    width: 225
                },
                {
                    name: "",
                    attribute: "copyRefID",
                    cell: "link",
                    cellClassName: "copy-icon",
                    cellOptions: {
                        icon: "glyphicon glyphicon-copy"
                    },
                    tooltip: "Copy to clipboard",
                    width: 45
                },
                {
                    name: "",
                    attribute: "delete",
                    cell: "link",
                    cellClassName: (model) => {
                        if (model && model.get("active") === false) {
                            return "hide-icon";
                        }
                        return "icon";
                    },
                    cellOptions: {
                        icon: "far fa-trash-alt delete-credential-icon"
                    },
                    tooltip: "Deactivate a credential",
                    width: 65
                }
            ]
        });
        SmartTable.prototype.initialize.apply(this, args);
    },
    
    deleteCredential(model) {
        sweetalert({
            title: "Deactivate credential",
            text: "Are you sure you want to deactivate this credential?",
            icon: "warning",
            buttons: {
                confirm: {
                    text: strings.deactivate,
                    className: "btn-confirm"
                },
                cancel: {
                    visible: true
                }
            }
        }).then((confirmed) => {
            if (confirmed) {
                model.destroy({
                    wait: true
                }).then(() => {
                    destroyPopovers();
                    toast.success("Credential has been deactivated");
                });
            }
        });
    },
    
    onClickCell(rowView, attr, rowModel, cell, event) {
        // Copy ref ids to clipboard
        if (attr === "copyRefID") {
            const text = rowModel.get("_id").trim();
            copyToClipboard(text);
            toast.success(`Ref ID ${text} copied to clipboard!`);
        } else if (attr === "delete") {
            this.deleteCredential(rowModel);
        } else {
            Radio.channel("credentials").trigger("credential:show", rowModel.id);
        }
    }
});
